import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Youtube = (props: SVGIcon) => (
  <svg {...props} width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.41 17.876l-3.494-.063c-1.132-.023-2.266.022-3.375-.209-1.688-.345-1.807-2.035-1.932-3.453a24.223 24.223 0 01.22-6c.183-1.109.905-1.77 2.023-1.843 3.773-.261 7.57-.23 11.335-.108.398.011.798.072 1.19.142 1.935.339 1.982 2.254 2.108 3.867.125 1.63.072 3.267-.167 4.885-.192 1.34-.559 2.463-2.108 2.571-1.94.142-3.837.256-5.783.22 0-.009-.01-.009-.016-.009zm-2.054-3.391c1.463-.84 2.897-1.666 4.351-2.5-1.465-.84-2.897-1.665-4.35-2.5v5z"
      fillRule="evenodd"
    />
  </svg>
)
